import { string2money } from 'common/utils/string';
import Stack from 'components/commons/stack';
import * as React from 'react';

import { PriceText } from './style';
interface Props {
  label: string;
  value?: string;
}
export default function DetailFee(props: Props) {
  const { label, value } = props;
  return (
    <Stack.Item direction="horizontal">
      <Stack.Item
        css={{ flex: 1, pr: 8 }}
        direction="horizontal"
        justify="between"
      >
        <PriceText css={{ flex: 1 }}>{label}</PriceText>
      </Stack.Item>
      <Stack.Item css={{ flex: 2 }}>
        <PriceText css={{ fontWeight: 600 }}>
          : Rp {(value && string2money(value)) || '-'}
        </PriceText>
      </Stack.Item>
    </Stack.Item>
  );
}
